import css from 'styled-jsx/css';
import { SITE_KEY } from 'constants/site';

const BYLINE_PLACEHOLDER_PALETTES = {
  at: {
    background: '#fcd1d4',
    color: '#f5656e'
  },
  cb: {
    background: '#ffc5c1',
    color: '#e2928c'
  },
  k: {
    background: '#ffe097',
    color: '#ffbb18'
  }
};

// these colors are more one-offs (for now)
const palette = {
  background: BYLINE_PLACEHOLDER_PALETTES[SITE_KEY].background,
  color: BYLINE_PLACEHOLDER_PALETTES[SITE_KEY].color
};

export default css`
  .BylineImagePlaceholder {
    padding: 0.5em;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${palette.color};
    background-color: ${palette.background};
  }
`;
